import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Typography,
    CircularProgress,
} from "@mui/material";
import Index from "../../Index";

const EInvoiceJsonModal = ({
    open,
    handleClose,
    handleConfirm,
    jsonData,
    isLoading,
    modelTitle,
    ButtonText
}) => {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
            aria-labelledby="e-invoice-dialog-title"
        >
            <DialogTitle id="e-invoice-dialog-title">
                {modelTitle || "JSON Data Preview"}
            </DialogTitle>

            <DialogContent>
                {isLoading ? (
                    // Loading State
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        minHeight="200px"
                    >
                        <CircularProgress />
                    </Box>
                ) : (
                    // JSON Content State
                    <Box>
                        <Typography variant="body1" gutterBottom sx={{ mb: 2 }}>
                            Please review the generated JSON data:
                        </Typography>

                        {/* JSON Viewer Box */}
                        <Box
                            sx={{
                                backgroundColor: "#fdfdfd", // Dark background like code editor
                                color: "#070707", // Light text color
                                padding: "15px",
                                borderRadius: "8px",
                                maxHeight: "400px",
                                overflow: "auto",
                                fontFamily: '"Fira Code", "Courier New", monospace',
                                fontSize: "14px",
                                border: "1px solid #3e4451",
                            }}
                        >
                            <pre style={{ margin: 0 }}>
                                {JSON.stringify(jsonData, null, 2)}
                            </pre>
                        </Box>
                    </Box>
                )}
            </DialogContent>

            {/* <DialogActions sx={{ p: 2, pt: 0 }}>
        <Button 
          onClick={handleClose} 
          color="secondary" 
          variant="outlined"
          disabled={isLoading}
        >
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          color="primary"
          variant="contained"
          disabled={isLoading}
        >
          OK
        </Button>
      </DialogActions> */}
            <DialogActions sx={{ p: 2, pt: 0 }}>
                <Index.Box className="btn-flex-end">
                    <Index.Box className="secondary-btn-main">
                        <Index.Button
                            className="secondary-button"
                            onClick={handleClose}
                            color="secondary"
                            variant="outlined"
                            disabled={isLoading}
                        >
                            Cancel
                        </Index.Button>
                    </Index.Box>
                    <Index.Box className="btn-primary-main">
                        <Index.Button
                            className="btn-primary"
                            onClick={handleConfirm}
                            color="primary"
                            variant="contained"
                            disabled={isLoading}
                        >
                            {ButtonText || "OK"}
                        </Index.Button>
                    </Index.Box>
                </Index.Box>
            </DialogActions>
        </Dialog>
    );
};

export default EInvoiceJsonModal;